import React, { useState, useCallback } from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'
import { highlightText } from '../utils/commonUtils'

function CopyableText({ value, toastLabel = 'Text', searchTerm }) {
    const [showToast, setShowToast] = useState(false)

    const handleCopy = useCallback(() => {
        if (!value) return
        navigator.clipboard.writeText(value).then(() => {
            setShowToast(true)
            setTimeout(() => setShowToast(false), 2000)
        }).catch((err) => {
            console.error('Failed to copy:', err)
        })
    }, [value])

    if (!value) return '-'

    return (
        <>
            <span
                role="button"
                tabIndex={0}
                onClick={(e) => { e.stopPropagation(); handleCopy(); }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        handleCopy()
                    }
                }}
                style={{
                    cursor: 'pointer',
                    borderBottom: '1px dashed #6c757d',
                    transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.borderBottom = '1px solid #0d6efd'
                    e.currentTarget.style.color = '#0d6efd'
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.borderBottom = '1px dashed #6c757d'
                    e.currentTarget.style.color = ''
                }}
                title={`Click to copy ${toastLabel}`}
            >
                {searchTerm ? highlightText(value, searchTerm) : value}
            </span>
            <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
                <Toast
                    show={showToast}
                    onClose={() => setShowToast(false)}
                    delay={2000}
                    autohide
                    bg="success"
                >
                    <Toast.Body className="text-white">
                        {toastLabel} <strong>{value}</strong> copied to clipboard!
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </>
    )
}

export default CopyableText
